import React, { useEffect, useState } from 'react';
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';
import { useSearchParams } from 'react-router-dom';

import { Button } from '@aws-amplify/ui-react';
import { Box, Grid } from '@mui/material';
import dayjs from 'dayjs';
import { useSetRecoilState } from 'recoil';

import { getAreaUsageStatusApi } from '@apis/index';
import { MessageDialogState } from '@atom/DialogState';
import { LoadingState } from '@atom/LoadingState';

import { GetAreaUsageStatusQueryVariables } from '../../../API';
import WeeklyScheduleTimeArea from './WeeklyScheduleTimeArea';
import WeeklyScheduleTimeLine from './WeeklyScheduleTimeLine';

const viewStyles = {
  width: '100%',
  display: 'flex',
  margin: 0,
  padding: 0,
  zIndex: 998
};

const Scheduler = () => {
  /* 共通State */
  const setMessageDialogState = useSetRecoilState(MessageDialogState);
  const setLoading = useSetRecoilState(LoadingState);

  const [searchParams] = useSearchParams();
  const [areaUsages, setAreaUsages] = useState<any>(null);
  const areaId = searchParams.get('areaId') ?? '';
  const facilityId = searchParams.get('facilityId') ?? '';

  // 一旦当日の日付。実際は選択された日付
  const [selectDay, setSelectDay] = useState(dayjs());

  const dispMonth = selectDay.format('YYYY年M月');

  // 直接書いていいかも
  const nextDay = () => setSelectDay(selectDay.add(7, 'day'));
  const prevDay = () => setSelectDay(selectDay.subtract(7, 'day'));

  // 検索処理
  const getData = async () => {
    setLoading(true);
    try {
      const input: GetAreaUsageStatusQueryVariables = {
        input: {
          areaId,
          facilityId,
          period: 7,
          startDate: selectDay.format('YYYY-MM-DD')
        }
      };
      const result = await getAreaUsageStatusApi(input);
      setAreaUsages(result);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      // eslint-disable-next-line no-console
      console.error(error);

      let message = '時間をおいてから再度お試しください。解決できない場合は管理者へお問い合わせください。';
      if ('errors' in error && error.errors.length !== 0) {
        message = error.errors[0].message;
      }
      setMessageDialogState({
        open: true,
        messageData: {
          title: 'エラーが発生しました。',
          message
        }
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [selectDay]);

  return (
    <Box display="Flex" sx={{ flexDirection: 'column' }}>
      <Box sx={{ position: 'fixed', width: '100%', backgroundColor: '#FFFFFF', zIndex: 998 }}>
        <Grid container spacing={2} direction="row" justifyContent="space-between" alignItems="center">
          <Grid item xs={3}>
            <Box sx={{ textAlign: 'left', marginLeft: '10px' }}>
              <Button
                style={{
                  backgroundColor: 'white',
                  color: '#667080',
                  borderColor: '#667080',
                  borderRadius: '15px',
                  fontWeight: '400',
                  fontSize: '10px'
                }}
                onClick={prevDay}
              >
                <MdArrowBackIos />
                先週
              </Button>
            </Box>
          </Grid>
          <Grid item xs="auto">
            <p>{dispMonth}</p>
          </Grid>
          <Grid item xs={3}>
            <Box sx={{ textAlign: 'right', marginRight: '10px' }}>
              <Button
                style={{
                  backgroundColor: 'white',
                  color: '#667080',
                  borderColor: '#667080',
                  borderRadius: '15px',
                  fontWeight: '400',
                  fontSize: '10px'
                }}
                onClick={nextDay}
              >
                翌週
                <MdArrowForwardIos />
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ marginTop: '55px' }}>
        {areaUsages && (
          <Box sx={viewStyles}>
            <WeeklyScheduleTimeLine startTime={areaUsages.usageStartTime} endTime={areaUsages.usageEndTime} />
            <WeeklyScheduleTimeArea areaUsages={areaUsages} />
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default Scheduler;
